//
import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import colors from '../../colors';

type Props = {
  style?: StyleProp<ViewStyle>;
};

const Divider: React.FC<Props> = (props) => {
  return <View style={[styles.divider, props.style]} />;
};

const styles = StyleSheet.create({
  divider: {
    height: 1,
    backgroundColor: colors.divider,
    width: '100%'
  }
});

export default Divider;
